"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const avatar_styles_1 = __importDefault(require("./avatar.styles"));
// This class has to display the picture in a hexagon shape
class OrganisationAvatar extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, src, className } = this.props;
            const { id } = this.state;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: "1.41421", clipRule: "evenodd", viewBox: "0 0 200 200", "aria-hidden": "true", className: classnames_1.default(classes.root, className) }, { children: [jsx_runtime_1.jsx("clipPath", Object.assign({ id: id }, { children: jsx_runtime_1.jsx("path", { d: "M200 100l-50 86.603H50L0 100l50-86.603h100L200 100z" }, void 0) }), void 0),
                    jsx_runtime_1.jsx("image", { clipPath: `url(#${id})`, width: "200", height: "200", xlinkHref: src }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M199.5,100l-49.75,86.17l-99.5,0l-49.75,-86.17l49.75,-86.17l99.5,0l49.75,86.17Z", strokeWidth: "1", fill: "none" }, void 0)] }), void 0));
        };
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        this.setState({
            id: lodash_uniqueid_1.default('clipPath-')
        });
    }
}
OrganisationAvatar.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    src: prop_types_1.default.string,
    className: prop_types_1.default.string
};
OrganisationAvatar.defaultProps = {
    className: null,
    src: null
};
exports.default = react_jss_1.default(avatar_styles_1.default)(OrganisationAvatar);
//# sourceMappingURL=index.js.map